import { JobApplicationDetailsView } from "@/views/job-applications/details/JobApplicationDetailsView";
import { JobApplicationsView } from "@/views/job-applications/list/JobApplicationsView";

export const views = {
  "job-applications.details": JobApplicationDetailsView,
  "job-applications": JobApplicationsView,
};
